import bgImage from '@/images/bg_vector.svg';
import searching_ticket from '@/images/searching_ticket.svg';
import ticket_found from '@/images/ticket_found.svg';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import styles from './RightPane.module.scss';

export const RightPane = () => {
  const pathname = usePathname();
  const img_vector = pathname === '/order-details/tickets-found/' ? ticket_found : searching_ticket;

  return (
    <div className={`${styles.right_pane_layout} flex-center`}>
      <div className={styles.right_pane_layout__image_wrapper}>
        <Image
          src={bgImage}
          width={100}
          height={100}
          alt="vector-background"
          className={styles.vector_bg}
        />
        <Image
          src={img_vector}
          width={40}
          height={100}
          alt="poster-abstract"
          className={styles.poster_abstract}
        />
      </div>
    </div>
  );
};
